<template>
<div class="trendGoalWrapper">

  <div class="subPart">
    <div :style="{ color: arrowColor() }"><v-icon scale="1" class="aok" :name="arrowIcon"></v-icon></div>
    <div class="valueDiv">{{value.deltaString}}</div>
  </div>

  <div v-if="value.goalString" class="subPart">
    <div><v-icon scale="1" class="aok" name="bullseye"></v-icon></div>
    <div class="valueDiv">{{value.goalString}}</div>
  </div>

</div>
</template>

<script>

export default {
  name: 'TrendGoalComponent',

  props: {
    value: Object,
    parentColor: String
  },

  data() {
    return {}
  },

  computed: {
    arrowIcon() {
      if(this.value) {
        if(this.value.arrow==='UP') return 'arrow-circle-up'
        if(this.value.arrow==='DOWN') return 'arrow-circle-down'
        if(this.value.arrow==='FLAT') return 'arrows-alt-h'
      }

      return 'question-circle'
    },


  },

  methods: {
    arrowColor() {
      if(this.value) {
        if(this.value.arrowColor === this.parentColor) {
          return 'black'
        }

        switch(this.value.arrowColor) {
          case 'GREEN':
            return '#29c43c'
          case 'RED':
            return '#c00000'
          case 'GREY':
            return 'grey'
        }
      }

      return 'transparent'
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .trendGoalWrapper {
    /*background-color: #ffc000;*/
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;

    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 4px;
    /*margin-bottom: 5px;*/
  }

  div.subPart {
    display: flex;
    flex-flow: row;
    align-items: center;
  }

  div.valueDiv {
    margin-left: 4px;
  }

</style>
